import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface GoogleMapsState {
  // State
  mapInstance: google.maps.Map | null;
  isMapReady: boolean;
  shouldInterceptPointer: boolean;

  // Actions
  setMapInstance: (map: google.maps.Map | null) => void;
  setMapReady: (ready: boolean) => void;
  setShouldInterceptPointer: (intercept: boolean) => void;
}

export const useGoogleMapsStore = create<GoogleMapsState>()(
  devtools(
    immer((set) => ({
      // Initial state
      mapInstance: null,
      isMapReady: false,
      shouldInterceptPointer: false,

      // Set map instance
      setMapInstance: (map: google.maps.Map | null) => {
        set({ mapInstance: map, isMapReady: !!map });
      },

      // Set map ready
      setMapReady: (ready: boolean) => {
        set({ isMapReady: ready });
      },

      // Set pointer interception
      setShouldInterceptPointer: (intercept: boolean) => {
        set({ shouldInterceptPointer: intercept });
      },
    })),
    { name: 'GoogleMapsStore' }
  )
);
